import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { SparkleDecoration } from './ui/SparkleDecoration';
export function TomosSection() {
  const tomos = [{
    number: 'Tomo 1',
    emoji: '📕',
    title: 'Mañanas en Calma',
    desc: 'Mañanas que fluyen sin gritos ni corridas',
    isCoral: true
  }, {
    number: 'Tomo 2',
    emoji: '📗',
    title: 'Tardes Sin Caos',
    desc: 'Tardes organizadas donde cada uno sabe qué hacer',
    isCoral: false
  }, {
    number: 'Tomo 3',
    emoji: '📘',
    title: 'Viandas y Almuerzo Sin Estrés',
    desc: 'Comidas saludables listas en minutos',
    isCoral: true
  }, {
    number: 'Tomo 4',
    emoji: '📙',
    title: 'Tareas en Orden',
    desc: 'Tus hijos haciendo las tareas solos',
    isCoral: false
  }, {
    number: 'Tomo 5',
    emoji: '📓',
    title: 'Organización Emocional',
    desc: 'Una familia que gestiona sus emociones',
    isCoral: true
  }, {
    number: 'Tomo 6',
    emoji: '📔',
    title: 'Aliados Digitales',
    desc: 'Las mejores apps para organizarte',
    isCoral: false
  }];
  return <section className="py-24 bg-cream relative mt-10" data-id="element-389">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-390">
        <AnimatedSection className="text-center mb-16 relative" data-id="element-391">
          <div className="inline-block relative" data-id="element-392">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-charcoal" data-id="element-393">
              Todo lo que recibís en el Mega Pack
            </h2>
            <div className="absolute -top-8 -right-10" data-id="element-394">
              <SparkleDecoration size={40} color="#E8735A" data-id="element-395" />
            </div>
          </div>
        </AnimatedSection>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 max-w-3xl mx-auto" data-id="element-396">
          {tomos.map((tomo, index) => {
          const colorSchemes = [{
            bg: 'bg-coral',
            border: 'border-coral',
            text: 'text-white',
            desc: 'text-white/85',
            badge: 'bg-white/20 text-white'
          }, {
            bg: 'bg-white',
            border: 'border-rose/30',
            text: 'text-charcoal',
            desc: 'text-charcoal/65',
            badge: 'bg-rose/20 text-coral'
          }, {
            bg: 'bg-burgundy',
            border: 'border-burgundy',
            text: 'text-white',
            desc: 'text-white/85',
            badge: 'bg-white/20 text-white'
          }, {
            bg: 'bg-rose/30',
            border: 'border-rose/40',
            text: 'text-burgundy',
            desc: 'text-burgundy/70',
            badge: 'bg-burgundy/15 text-burgundy'
          }, {
            bg: 'bg-coral',
            border: 'border-coral',
            text: 'text-white',
            desc: 'text-white/85',
            badge: 'bg-white/20 text-white'
          }, {
            bg: 'bg-white',
            border: 'border-rose/30',
            text: 'text-charcoal',
            desc: 'text-charcoal/65',
            badge: 'bg-rose/20 text-coral'
          }];
          const scheme = colorSchemes[index];
          return <AnimatedSection key={index} delay={index * 0.08} className={`relative rounded-2xl p-4 md:p-5 card-relief border ${scheme.bg} ${scheme.border} text-center overflow-hidden group hover:-translate-y-1 transition-all duration-300 cursor-pointer`} data-id="element-397">
                {/* Emoji */}
                <span className="text-2xl md:text-3xl block mb-2" data-id="element-398">
                  {tomo.emoji}
                </span>
                {/* Badge */}
                <span className={`inline-block font-bold text-[10px] tracking-wider uppercase px-3 py-0.5 rounded-full mb-2 ${scheme.badge}`} data-id="element-399">
                  {tomo.number}
                </span>
                {/* Title */}
                <h3 className={`text-sm md:text-base font-serif font-bold mb-1 leading-snug ${scheme.text}`} data-id="element-400">
                  {tomo.title}
                </h3>
                {/* Description */}
                <p className={`text-xs md:text-sm leading-relaxed ${scheme.desc}`} data-id="element-401">
                  {tomo.desc}
                </p>
              </AnimatedSection>;
        })}
        </div>
      </div>
    </section>;
}